// CollectionMovedChips — the orders.collection_moved bell's body (C7 Commit 3):
// `date · time · order sheet import · locked in Developments`, then up to six
// chips of photo + code, `+N more` after them. Click-through is the row's /
// card's own Open (entityRoutes: collection_run → the Collection Wall).
//
// ⚠️ P6 §2.4 — no picture is read from the payload. The notification row is
// shared by every recipient, so a URL placed there would escape the reader's
// access filter; the payload's devs[] is used for the dev ids and codes only,
// and each photo is resolved by THIS reader from their own collection_cards
// read (the Collection's cached query, under their RLS). A reader without the
// Orders portal sees the codes without pictures.
import React, { useMemo } from 'react';
import styles from './notificationDrawer.module.css';
import { useQuery } from '@tanstack/react-query';
import { fetchCollectionCards, cardsQueryKey, COLLECTION_SEASON_YEAR } from '../../portals/orders/collection/api';

export const COLLECTION_MOVED = 'orders.collection_moved';

export default function CollectionMovedChips({ n }) {
  const devs = Array.isArray(n?.payload?.devs) ? n.payload.devs : [];
  // the SAME cache entry as the Collection's useCollectionCards on Sun (['collection','cards',year,'sun']) — imported
  // through api.js alone so the bell does not pull the Orders chunk's hooks into the main bundle.
  // C8 · the lock and this bell are Sun only (D-C8-1), whatever line the Collection shows.
  const q = useQuery({ queryKey: cardsQueryKey(COLLECTION_SEASON_YEAR, 'sun'), enabled: devs.length > 0, staleTime: 60 * 1000, retry: false, queryFn: () => fetchCollectionCards(COLLECTION_SEASON_YEAR, 'sun') });
  const read = { cards: q.data?.cards || [] };
  const photoOf = useMemo(() => new Map((read.cards || []).filter((c) => c.dev_id).map((c) => [c.dev_id, c.photo])), [read.cards]);
  const at = n?.payload?.run_at || n?.created_at;
  const d = at ? new Date(at) : null;
  const when = d && !Number.isNaN(d.getTime())
    ? `${d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })} · ${d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}` : '';
  const more = (Number(n?.payload?.more) || 0) + Math.max(0, devs.length - 6);
  return (
    <div className={styles.cmBlock} data-test="collection-moved">
      <div className={styles.cmMeta}>{[when, 'order sheet import', 'locked in Developments'].filter(Boolean).join(' · ')}</div>
      <div className={styles.cmList}>
        {devs.slice(0, 6).map((x) => {
          const url = photoOf.get(x.dev_id);
          const code = String(x.code || x.dev_number || '');
          return <span key={x.dev_id || code} className={styles.cmChip} data-test="collection-moved-chip">{url ? <img src={url} alt="" loading="lazy" /> : null}{code}</span>;
        })}
        {more > 0 ? <span className={styles.cmMore}>+{more} more</span> : null}
      </div>
    </div>
  );
}
